/**
 * CSS variable to animate the pagination dash from `.paginationDashAnimated` in `@/app/components/navigation/pagination/pagination-dash`
 */
export const SLIDE_PROGRESS_CSS_VAR = '--slide-progress';
